import { render } from "./StaffWiseReport.vue?vue&type=template&id=e1d5da70"
import script from "./StaffWiseReport.vue?vue&type=script&lang=js"
export * from "./StaffWiseReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__